// FABButton.tsx — schwebender „Neuer Termin"-Button für den Mobile-Kalender
// (`/termine`, SP6). Rendert NUR auf dem Phone (useResponsive().isPhone), fixed
// unten-rechts mit safe-area-Abstand. onClick wird von der Shell mit
// openTerminFormWindow(openWindow, { mailbox: currentMailbox }) verdrahtet
// (ohne Zeit-Prefill).

import React from "react";
import { useResponsive } from "../../hooks/useResponsive";

export interface FABButtonProps {
    onClick: () => void;
    /** a11y-Label, default „Neuer Termin". */
    label?: string;
}

export const FABButton: React.FC<FABButtonProps> = ({ onClick, label = "Neuer Termin" }) => {
    const { isPhone } = useResponsive();
    if (!isPhone) return null;

    return (
        <button
            type="button"
            className="cal-fab"
            aria-label={label}
            title={label}
            onClick={onClick}
        >
            <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden>
                <path
                    d="M12 5v14M5 12h14"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                />
            </svg>
        </button>
    );
};

export default FABButton;
